import menu from '@/content/menu.json';
import Menu from './Menu';

export default function FooterMenuResources() {
  return <Menu title={menu.resources.title} items={menu.resources.items} />;
}
